import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useDispatch, useSelector } from "react-redux";
import { Link as Link2 } from "react-router-dom";
import { getCertificates } from "../../Slices/certificates";
import AdditionalForm from "../../Components/AdditionalForm";
import Skeleton from "@mui/material/Skeleton";
import { useDocumentTitle } from "../../Hooks/useDocumentTitle";
import { Footer } from "../../Components/Footer";
import Logo from "../../assets/logo.png";
import HeroTitleBox from "../../Components/HeroTitleBox";

export default function Certificates() {
  useDocumentTitle("certyfikaty");
  const dispatch = useDispatch();

  const {
    user,
    accessToken: token,
  } = useSelector((state) => state.auth);
  const certificates = useSelector((state) => state.certificates);

  useEffect(() => {
    dispatch(getCertificates({ user: token }));
  }, []);

  console.log("certificates", certificates)

  return (
    <>
      <main>
        <HeroTitleBox title="Galeria Certyfikatów" subtitle="Galeria posiadanych przez Ciebie certyfikatów" />

        {user.phone ? (
          <Container
            maxWidth="lg"
            sx={{
              py: { xs: 5, md: 8 },
              px: { xs: 2, md: 3 },
            }}
          >

            <Grid container spacing={4}>
              {certificates.map((certificate) => (
                <Grid item key={certificate.id} xs={12} sm={6} md={4}>
                  <Card
                    sx={{
                      position: "relative",
                      width: "100%",
                      aspectRatio: "1.414 / 1",
                      borderRadius: 1,
                      overflow: "hidden",
                      // border: "1px solid rgba(255,255,255,0.3)",
                      boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
                      transition: "all 0.35s ease",
                      backgroundImage: `url(${certificate.certificate_url})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      cursor: "pointer",

                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: "0 20px 50px rgba(0,0,0,0.22)",
                        transition: "all 0.35s ease",

                        "& .certificate-bg": {
                          transform: "scale(1.04)",
                        },

                        "& .certificate-overlay": {
                          opacity: 1,
                        },

                        "& .certificate-button": {
                          transform: "translateY(0)",
                          opacity: 1,
                        },
                      },
                    }}
                  >
                    <Box
                      className="certificate-bg"
                      sx={{
                        position: "absolute",
                        inset: 0,
                        backgroundImage: `url(${certificate.certificate_url})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        transition: "transform 0.6s ease",
                      }}
                    />

                    <Box
                      className="certificate-overlay"
                      sx={{
                        position: "absolute",
                        inset: 0,
                        background:
                          "linear-gradient(180deg, rgba(0,0,0,0.05) 20%, rgba(0,0,0,0.75) 100%)",
                        opacity: 0.8,
                        transition: "opacity 0.35s ease",
                      }}
                    />

                    <Link2
                      to={`/certificates/${certificate.id}`}
                      style={{
                        position: "absolute",
                        inset: 0,
                        zIndex: 5,
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    />

                    <Box
                      sx={{
                        position: "absolute",
                        inset: 0,
                        zIndex: 2,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        p: { xs: 2, md: 2.5 },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                        }}
                      >
                        <Box
                          sx={{
                            width: 42,
                            height: 42,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "rgba(255, 255, 255, 0.53)",
                            backdropFilter: "blur(8px)",
                            boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: 20,
                            }}
                          >
                            <img
                              src={Logo}
                              alt="Logo Micree"
                              style={{ maxWidth: "36px", marginBottom: "2px" }}
                            />
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            px: 1.5,
                            py: 0.7,
                            borderRadius: 2,
                            background: "rgba(255, 255, 255, 0.49)",
                            border: "1px solid rgba(48, 48, 48, 0.35)",
                            backdropFilter: "blur(8px)",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 700,
                              color: "#333",
                            }}
                          >
                            {certificate.issuanceDate}
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          color: "#fff",
                          maxWidth: "90%",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "1.1rem",
                              md: "1.35rem",
                            },
                            fontWeight: 800,
                            lineHeight: 1.2,
                            textShadow: "0 2px 8px rgba(0,0,0,0.5)",
                            mb: 1,
                          }}
                        >
                          {certificate.badgeName}
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            letterSpacing: "0.08em",
                            textTransform: "uppercase",
                            opacity: 0.8,
                            mb: 1.5,
                          }}
                        >
                          Certyfikat
                        </Typography>

                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 1,
                            px: 1.5,
                            py: 0.7,
                            borderRadius: 2,
                            background: "rgba(0,0,0,0.35)",
                            backdropFilter: "blur(8px)",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "0.65rem",
                              opacity: 0.7,
                            }}
                          >
                            NR.
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 700,
                            }}
                          >
                            {certificate.slug}
                          </Typography>
                        </Box>
                      </Box>

                      <Button
                        className="certificate-button"
                        variant="contained"
                        sx={{
                          position: "absolute",
                          right: 20,
                          bottom: 20,
                          zIndex: 10,
                          borderRadius: 2,
                          textTransform: "none",
                          fontWeight: 700,
                          px: 2,
                          py: 1,

                          opacity: 0,
                          transform: "translateY(10px)",
                          transition: "all 0.3s ease",

                          background: "rgba(255,255,255,0.95)",
                          color: "#11334b",

                          "&:hover": {
                            background: "#fff",
                          },
                        }}
                      >
                        Wyświetl →
                      </Button>
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Container>
        ) : (
          <>
            <Container
              sx={{
                position: "relative",
                py: 6,
              }}
            >
              <AdditionalForm />

              <Grid container spacing={2}>
                {[1, 2, 3].map((item) => (
                  <Grid item md={4} xs={12} key={item}>
                    <Stack spacing={1}>
                      <Skeleton
                        variant="rectangular"
                        height={220}
                        sx={{ borderRadius: 3 }}
                      />
                      <Skeleton variant="text" height={50} />
                    </Stack>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </>
        )}

        <Footer />
      </main>
    </>
  );
}






// import React, { useEffect } from "react";
// import Button from "@mui/material/Button";
// import Card from "@mui/material/Card";
// import CardActions from "@mui/material/CardActions";
// import CardContent from "@mui/material/CardContent";
// import CardMedia from "@mui/material/CardMedia";
// import Grid from "@mui/material/Grid";
// import Stack from "@mui/material/Stack";
// import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
// import Container from "@mui/material/Container";
// import { useDispatch, useSelector } from "react-redux";
// import { Link as Link2 } from "react-router-dom";
// import { getCertificates } from "../../Slices/certificates";
// import AdditionalForm from "../../Components/AdditionalForm";
// import Skeleton from "@mui/material/Skeleton";
// import { useDocumentTitle } from "../../Hooks/useDocumentTitle";
// import { Footer } from "../../Components/Footer";

// export default function Certificates() {
//   useDocumentTitle("certyfikaty");
//   const dispatch = useDispatch();

//   const { user } = useSelector((state) => state.auth);
//   const certificates = useSelector((state) => state.certificates);

//   useEffect(() => {
//     dispatch(getCertificates({ user: user.jwt }));
//   }, []);

//   return (
//     <>
//       <main>
//         <Box
//           sx={{
//             bgcolor: "background.paper",
//             pt: 8,
//             pb: 0,
//           }}
//         >
//           <Container maxWidth="sm">
//             <Typography
//               component="h1"
//               variant="h2"
//               align="center"
//               color="text.primary"
//               gutterBottom
//             >
//               Galeria Certyfikatów
//             </Typography>
//             <Typography
//               variant="h5"
//               align="center"
//               color="text.secondary"
//               paragraph
//             >
//               Galeria posiadanych przez Ciebie certyfikatów
//             </Typography>
//             <Stack
//               sx={{ pt: 4 }}
//               direction="row"
//               spacing={2}
//               justifyContent="center"
//             ></Stack>
//           </Container>
//         </Box>
//         {user.phone ? (
//           <Container sx={{ py: 8 }} maxWidth="md">
//             <Grid container spacing={4}>
//               {certificates.map((certificate) => (
//                 <Grid item key={certificate.id} xs={12} sm={6} md={4}>
//                   <Card
//                     sx={{
//                       height: "100%",
//                       display: "flex",
//                       flexDirection: "column",
//                     }}
//                   >
//                     <Link2
//                       to={`/certificates/${certificate.id}`}
//                       style={{ textDecoration: "none" }}
//                     >
//                       <CardMedia
//                         component="img"
//                         image={certificate.certificate_url}
//                         alt="random"
//                       />
//                     </Link2>
//                     <CardContent sx={{ flexGrow: 1 }}>
//                       <Typography gutterBottom variant="h5" component="h2">
//                         {certificate.badgeName}
//                       </Typography>
//                       <Typography
//                         variant="h6"
//                         sx={{ fontSize: "12px", fontWeight: "200" }}
//                       >
//                         NR. CERT:{" "}
//                         <span style={{ fontWeight: "bold" }}>
//                           {certificate.slug}
//                         </span>
//                       </Typography>
//                       <Typography
//                         variant="h6"
//                         sx={{ fontSize: "12px", fontWeight: "200" }}
//                       >
//                         WYDANO:{" "}
//                         <span style={{ fontWeight: "bold" }}>
//                           {certificate.issuanceDate}
//                         </span>
//                       </Typography>
//                     </CardContent>
//                     <CardActions sx={{ alignSelf: "center" }}>
//                       <Link2
//                         to={`/certificates/${certificate.id}`}
//                         style={{ textDecoration: "none" }}
//                       >
//                         <Button variant="outlined" size="small">
//                           Wyświetl
//                         </Button>
//                       </Link2>
//                     </CardActions>
//                   </Card>
//                 </Grid>
//               ))}
//             </Grid>
//           </Container>
//         ) : (
//           <>
//             <Container sx={{ position: "relative" }}>
//               <AdditionalForm />
//               <Grid container spacing={2}>
//                 <Grid item md={4} xs={12}>
//                   <Stack spacing={1}>
//                     <Skeleton variant="rectangular" height={180} />
//                     <Skeleton variant="text" height={50} />
//                   </Stack>
//                 </Grid>
//                 <Grid item md={4} xs={12}>
//                   <Stack spacing={1}>
//                     <Skeleton variant="rectangular" height={180} />
//                     <Skeleton variant="text" height={50} />
//                   </Stack>
//                 </Grid>
//                 <Grid item md={4} xs={12}>
//                   <Stack spacing={1}>
//                     <Skeleton variant="rectangular" height={180} />
//                     <Skeleton variant="text" height={50} />
//                   </Stack>
//                 </Grid>
//               </Grid>
//             </Container>
//           </>
//         )}

//         <Footer />
//       </main>
//     </>
//   );
// }
